import { Select } from 'antd'
import { AntSelect, AntSelectOption, AntSelectOptionGroup } from './styles/select.style'

const SelectOption = AntSelectOption(Select.Option)
const SelectOptGroup = AntSelectOptionGroup(Select.OptGroup)

export default AntSelect(Select)
export { SelectOption, SelectOptGroup }
